import { type EnhancedWalletCurrency, useLimitLedgerRemainingQuery } from '@capsicum/features/wallet/shared';

export const useLimitLedgerRemaining = (cryptoCurrency?: EnhancedWalletCurrency, enabled = true) => {
	const {
		data: ledgerLimitData,
		error: ledgerLimitError,
		isLoading: isLedgerLimitLoading
	} = useLimitLedgerRemainingQuery(
		{
			batchType: 'buy',
			'convertAmountToCurrencies[]': cryptoCurrency?.id ? [cryptoCurrency?.id] : undefined,
			currencyId: cryptoCurrency?.id,
			movementType: 'credit'
		},
		enabled
	);

	return { isLedgerLimitLoading, ledgerLimitData, ledgerLimitError };
};
